import { render, staticRenderFns } from "./DashboardCardTemplate.vue?vue&type=template&id=78bd4020&scoped=true&"
import script from "./DashboardCardTemplate.vue?vue&type=script&lang=ts&"
export * from "./DashboardCardTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCardTemplate.vue?vue&type=style&index=0&id=78bd4020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd4020",
  null
  
)

export default component.exports